'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgFlashOff(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", null,
            React__default.default.createElement("path", { d: "M10.7195 8.09408C10.9107 7.73481 10.6753 7.28975 10.2978 7.28975H9.38073L10.4988 8.51233L10.7195 8.09408ZM10.7979 3.77752C10.9598 3.41825 10.7244 3 10.3566 3H6.73757C6.46785 3 6.24718 3.2413 6.24718 3.53622V3.86331L9.25323 7.15033L10.7979 3.77752ZM11.8572 11.5152L4.83488 3.8365C4.64363 3.62738 4.33469 3.62738 4.14344 3.8365C3.95219 4.04563 3.95219 4.38345 4.14344 4.59257L6.24718 6.89831V8.36219C6.24718 8.65711 6.46786 8.89841 6.73757 8.89841H7.71833V12.7324C7.71833 13.0058 8.04689 13.1024 8.17439 12.8664L9.47391 10.4266L11.1608 12.2712C11.3521 12.4804 11.661 12.4804 11.8523 12.2712C12.0484 12.0621 12.0484 11.7243 11.8572 11.5152Z", fill: "currentColor" }))));
}

module.exports = SvgFlashOff;
//# sourceMappingURL=FlashOff.js.map
